import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import Backend, { HttpBackendOptions } from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
    // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
    // learn more: https://github.com/i18next/i18next-http-backend
    // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
    .use(Backend)

    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init<HttpBackendOptions>({
        supportedLngs: ["en", "de"],
        saveMissing: false,
        fallbackLng: "en",
        debug: true,
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        backend: {
            loadPath: "/translations/{{lng}}/{{ns}}.json",
        },
    });

// Keep `<html lang>` in sync with the language we actually render.
//
// If they disagree, browsers detect a foreign-language page and offer - or, once the user accepted
// that offer, silently perform - a page translation. That rewrites the dom behind react's back and
// breaks its updates (see the comment in `components/base/table.tsx`).
const syncDocumentLang = (lng: string) => {
    document.documentElement.lang = lng;
};
i18n.on("languageChanged", syncDocumentLang);
if (i18n.resolvedLanguage) {
    syncDocumentLang(i18n.resolvedLanguage);
}

export default i18n;
